// topoEditor/pickers/listPicker.js — a generic editor-popover picker. Given an async provider of [{ id, title }],
// returns a picker(applyValues) => HTMLElement: a short, scrollable list (capped ~5 rows via CSS). Clicking a row
// calls applyValues({ id }) → the popover's id field is filled. Data-source-free → the overlay picker
// (get_overlays) and a later tag picker (get_tags) reuse this verbatim; only the injected provider differs.

export function makeListPicker(provider) {
    return function picker(applyValues) {
        const box = document.createElement("div");
        box.className = "topo2-editor-pop-list";

        const status = document.createElement("div");
        status.className = "topo2-editor-pop-list-status";
        status.textContent = "…";
        box.appendChild(status);

        Promise.resolve()
            .then(provider)
            .then((items) => {
                box.innerHTML = "";
                if (!items || !items.length) { status.textContent = "—"; box.appendChild(status); return; }
                items.forEach((it) => {
                    const row = document.createElement("button");
                    row.type = "button";
                    row.className = "topo2-editor-pop-listitem";
                    // Eine Spalte, Form "ID – Titel" (User 2026-09-23). Die ID steht VORNE, weil sie der Wert
                    // ist, der gespeichert wird, und weil die Zeilen so an einer festen Kante beginnen. Vorher
                    // stand der Titel vorne und die ID rechts danach — bei langen Titeln wurde die ID an den
                    // Listenrand gedrückt und abgeschnitten. Jetzt nimmt die Zeile die volle Breite des
                    // Containers und der Titel darf umbrechen, statt waagrecht zu rollen.
                    row.innerHTML = "";
                    const idEl = document.createElement("span");
                    idEl.className = "topo2-editor-pop-listitem-id";
                    idEl.textContent = it.id;
                    const t = document.createElement("span");
                    t.className = "topo2-editor-pop-listitem-title";
                    t.textContent = it.title;
                    row.appendChild(idEl);
                    row.append(" – ");
                    row.appendChild(t);
                    row.addEventListener("click", () => applyValues({ id: String(it.id) }));
                    box.appendChild(row);
                });
            })
            .catch(() => { status.textContent = "—"; });

        return box;
    };
}
